import { render, staticRenderFns } from "./FichaA4.vue?vue&type=template&id=92636b88&scoped=true&"
import script from "./FichaA4.vue?vue&type=script&lang=js&"
export * from "./FichaA4.vue?vue&type=script&lang=js&"
import style0 from "./FichaA4.vue?vue&type=style&index=0&id=92636b88&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92636b88",
  null
  
)

export default component.exports